import { API } from "../../../utils";

export const getStockItemsListApi = async (params = {}) => {
  const response = await API.get("/stocks", { params });
  return response.data;
};

export const getThresholdsListApi = async (params = {}) => {
  const response = await API.get("/thresholds", { params });
  return response.data;
};

export const getStockItemDetailsApi = async (id) => {
  const response = await API.get(`/stocks/${id}`);
  return response.data.data;
};

export const createThresholdApi = async (formData) => {
  const response = await API.post("/thresholds", formData);
  return response.data;
};

export const getStoreThresholdsApi = async (stockId) => {
  const response = await API.get(`/stocks/${stockId}/store-thresholds`);
  return response.data;
};

export const updateStoreThresholdApi = async ({ stockId, storeId, data }) => {
  const response = await API.put(
    `/stocks/${stockId}/store-thresholds/${storeId}/threshold`,
    data,
  );
  return response.data;
};

export const updateStoreVisibilityApi = async ({ stockId, storeId, data }) => {
  const response = await API.put(
    `/stocks/${stockId}/store-thresholds/${storeId}/visibility`,
    data,
  );
  return response.data;
};

// create fake promise to simulate api call
export const updateStoreBulkVisibilityApi = async ({ stockId, data }) => {
  const response = await API.put(
    `stocks/${stockId}/store-thresholds/visibility`,
    data,
  );
  return response.data;
};

export const updateBulkVisibilityApi = async ({ storeId, data }) => {
  const response = await API.put(
    `stores/${storeId}/stock-thresholds/visibility`,
    data,
  );
  return response.data;
};
